import { SAVING_LIMIT_PRICE } from "@/constants";
import { FUSION_CATEGORY, FUSION_CATEGORY_NAMES, USUARIO_LIBRE_CON_LINEA_MOVIL, USUARIO_LIBRE_SIN_LINEA_MOVIL, USUARIO_LOGADO, USUARIO_NO_LOGADO, USUARIO_PRIMER_R2R_INCLUIDO, USUARIO_R2R_ADICIONAL, USUARIO_R2R_ADICIONAL_CON_RENOVACION, USUARIO_SEGUNDO_R2R_INCLUIDO } from "@/constants/get-my-products";
import { calculateSavingR2R, calculateTotalAmountR2R, parsePrice } from "@/utils/common/price";
import { getMainImageDevice, isMovistarSwapOffer } from "@/utils/dataHandlerDetailedProduct";
import { getFullUrl } from "@/utils/htmlUtils";

export const normalizeGetAllItemResponse = (response, offerCategory) => {

  return response;
}

export const getR2RPriceByFusionCategory = (offer, categoryFusionInfo, type = "r2r") => {
  if (!categoryFusionInfo) {
    categoryFusionInfo = FUSION_CATEGORY_NAMES.AV;
  }
  let monthlyFinalPrice = null;
  let monthlyPriceBeforeDiscounts = null;
  let moreThanOneQuota = false;
  let totalAmount = null;
  let installments = null;

  if (type === "r2r") {
    if (
      offer[`pvp_fusion_${categoryFusionInfo}_promo`] !== "" &&
      offer[`pvp_fusion_${categoryFusionInfo}_promo`] !== "-" &&
      offer[`pvp_fusion_${categoryFusionInfo}_promo`] !== undefined
    ) {
      monthlyFinalPrice = offer[`pvp_fusion_${categoryFusionInfo}_promo`];
    }
    if (
      offer[`pvp_fusion_${categoryFusionInfo}`] !== "" &&
      offer[`pvp_fusion_${categoryFusionInfo}`] !== "-" &&
      offer[`pvp_fusion_${categoryFusionInfo}`] !== undefined
    ) {
      if (monthlyFinalPrice) {
        monthlyPriceBeforeDiscounts = offer[`pvp_fusion_${categoryFusionInfo}`];
      } else {
        monthlyFinalPrice = offer[`pvp_fusion_${categoryFusionInfo}`];
      }
    }
    totalAmount = calculateTotalAmountR2R(monthlyFinalPrice);
    installments = "48";
  } else if (type === "r2rAdditional") {
    if (offer[`monthlyPayment48`] > -1) {
      installments = "48";
      monthlyFinalPrice = offer[`monthlyPayment48`];
      totalAmount = calculateTotalAmountR2R(monthlyFinalPrice, 48)
    } else if (offer[`monthlyPayment36`] > -1) {
      installments = "36";
      monthlyFinalPrice = offer[`monthlyPayment36`];
      totalAmount = calculateTotalAmountR2R(monthlyFinalPrice, 36)
    } else {
      installments = "24";
      monthlyFinalPrice = offer[`monthlyPayment24`];
      totalAmount = calculateTotalAmountR2R(monthlyFinalPrice, 24)
    }
    const quotas = [
      offer.monthlyPayment24,
      offer.monthlyPayment36,
      offer.monthlyPayment48,
    ];
    const validQuotas = quotas.filter(quota => quota > -1);
    moreThanOneQuota = validQuotas.length > 1;
    //Se toma la menor de las cuotas (estara en la ultima posicion)
    monthlyFinalPrice = validQuotas.at(-1) ?? null;
  }
  return {
    monthlyFinalPrice,
    monthlyPriceBeforeDiscounts,
    moreThanOneQuota,
    totalAmount,
    installments
  }
}

export const getFreeOfferPrice = (offer) => {
  let finalPrice = null, finalPriceBeforeDiscounts = null;
  if (offer) {
    finalPrice = offer.currentPrice;
    if (offer.originalPrice > 0 && offer.originalPrice !== offer.currentPrice) {
      finalPriceBeforeDiscounts = offer.originalPrice;
    }
  }
  return {
    finalPrice,
    finalPriceBeforeDiscounts
  }
}

export const getR2RTypeByOfferCategory = (offerCategory) => {
  let fusionCategoryId = null;
  let clientType = null;
  switch (offerCategory) {
    case "FUSION_AV" || Array.isArray(offerCategory) && offerCategory.includes("FUSION_AV"):
      fusionCategoryId = FUSION_CATEGORY.AV;
      clientType = USUARIO_PRIMER_R2R_INCLUIDO;
      break;
    case "FUSION_AV_ADDITIONAL" || Array.isArray(offerCategory) && offerCategory.includes("FUSION_AV_ADDITIONAL"):
      fusionCategoryId = FUSION_CATEGORY.AV;
      clientType = USUARIO_R2R_ADICIONAL;
      break;
    case "FUSION_MV" || Array.isArray(offerCategory) && offerCategory.includes("FUSION_MV"):
      fusionCategoryId = FUSION_CATEGORY.MV;
      clientType = USUARIO_PRIMER_R2R_INCLUIDO;
      break;
    case "FUSION_MV_ADDITIONAL" || Array.isArray(offerCategory) && offerCategory.includes("FUSION_MV_ADDITIONAL"):
      fusionCategoryId = FUSION_CATEGORY.MV;
      clientType = USUARIO_R2R_ADICIONAL;
      break;
    case "FUSION_BV" || Array.isArray(offerCategory) && offerCategory.includes("FUSION_BV"):
      fusionCategoryId = FUSION_CATEGORY.BV;
      clientType = USUARIO_PRIMER_R2R_INCLUIDO;
      break;
    case "FUSION_BV_ADDITIONAL" || Array.isArray(offerCategory) && offerCategory.includes("FUSION_BV_ADDITIONAL"):
      fusionCategoryId = FUSION_CATEGORY.BV;
      clientType = USUARIO_R2R_ADICIONAL;
      break;
    default:
  }
  return { fusionCategoryId, clientType };
}

export const getOfferCategoryByClient = (fusionCategoryId, clientType, hasToShowR2RRenovationOffers, isRenewR2RBtl) => {
  let offerCategory;
  //Por si no viene el btl con offer category
  if (isRenewR2RBtl) {
    offerCategory = `FUSION_AV`
  }
  switch (clientType) {
    case USUARIO_PRIMER_R2R_INCLUIDO:
    case USUARIO_SEGUNDO_R2R_INCLUIDO:
    case USUARIO_R2R_ADICIONAL:
    case USUARIO_NO_LOGADO:
    case USUARIO_R2R_ADICIONAL_CON_RENOVACION:
      switch (fusionCategoryId) {
        case FUSION_CATEGORY_NAMES.AV:
          offerCategory = `FUSION_AV`
          break;
        case FUSION_CATEGORY_NAMES.MV:
          offerCategory = `FUSION_MV`
          break;
        case FUSION_CATEGORY_NAMES.BV:
          offerCategory = `FUSION_BV`
          break;
        default:
          offerCategory = `FUSION_AV`
      }
      if (clientType === USUARIO_R2R_ADICIONAL || (clientType === USUARIO_R2R_ADICIONAL_CON_RENOVACION && !hasToShowR2RRenovationOffers)) {
        offerCategory = `${offerCategory}_ADDITIONAL`
      }
      break;
    //Usuarios sin derecho a R2R
    case USUARIO_LOGADO:
    case USUARIO_LIBRE_SIN_LINEA_MOVIL:
    case USUARIO_LIBRE_CON_LINEA_MOVIL:
      offerCategory = `PARTICULARES`
      break;
    default:
  }
  return offerCategory;
}

export const composeOfferObject = ({ type, finalPrice, finalPriceBeforeDiscounts, monthlyFinalPrice, installments, finalFusionCategoryId, errorCategoryFusionInfo, moreThanOneQuota, swapOfferInfo, offerSaving, profileId, userDiscountNewModelR2R }) => {
  let isSwapOffer = null, swapRenewalPeriod = null;
  if (swapOfferInfo) {
    ({ isSwapOffer, swapRenewalPeriod } = swapOfferInfo);
  }
  switch (type) {
    case "r2r":
      const offers = {
        r2r: {
          title: finalFusionCategoryId && !errorCategoryFusionInfo ? '' : 'Desde',
          finalPrice: !isSwapOffer ? finalPrice : null,
          finalPriceBeforeDiscounts: !isSwapOffer ? finalPriceBeforeDiscounts : null,
          //priceBeforeDiscounts,
          //finalPriceBeforeDiscounts,
          monthlyFinalPrice,
          //currency: '€',
          //quote: ``,
          installmentsText: !isSwapOffer ? `En ${installments} cuotas de ${monthlyFinalPrice} €/mes` : null,
          forcePromo: false,
          afterOfferText: isSwapOffer ? `Cámbialo en ${swapRenewalPeriod} meses` : "",
          afterOfferText2: null,
          isSwapOffer,
        }
      }
      //Contingencia. Swap no muestra precio final, y no se tiene en cuenta el ahorro
      if (userDiscountNewModelR2R && isSwapOffer) {
        offers.r2r.afterOfferText2 = `Incluye descuento ${userDiscountNewModelR2R}€`;
      }
      return offers;
    case "r2rAdditional":
      return {
        r2rAdditional: {
          title: moreThanOneQuota ? 'Desde' : '',
          finalPrice: !isSwapOffer ? finalPrice : null,
          finalPriceBeforeDiscounts: !isSwapOffer ? finalPriceBeforeDiscounts : null, monthlyFinalPrice,
          monthlyFinalPrice,
          installmentsText: !isSwapOffer ? `En ${installments} cuotas de ${parsePrice(monthlyFinalPrice)} €/mes` : null,
          //currency: '€',
          //quote: 'mes',
          afterOfferText: isSwapOffer ? `Cámbialo en ${swapRenewalPeriod} meses` : "",
          isSwapOffer,
        }
      }
    case "libre":
      return {
        libre: {
          title: '',
          finalPrice,
          finalPriceBeforeDiscounts,
          //currency: '€',
        }
      }
    default:
      return null;
  }
}

export const getCustoStampByOffer = (offer, custoStamps) => {
  const tags = offer.tags;
  let stamp = null;
  if (Array.isArray(custoStamps) && Array.isArray(tags) && custoStamps.length > 0 && tags.length > 0) {
    const stampToApply = custoStamps.find((custoStamp) => tags.find(tag => custoStamp.tag === tag));
    if (stampToApply) {
      stamp = stampToApply;
    }
  }
  return stamp;
}

export const normalizeProducts = ({
  products,
  finalClientType,
  userFinancing,
  finalFusionCategoryId,
  errorCategoryFusionInfo,
  userDiscountNewModelR2R,
  profiles,
  queryParams = {},
  custoStamps,
  hasToShowR2RRenovationOffers
}) => {
  const productsCards = [];

  products.forEach((product) => {
    const productItem = {
      name: product.name,
      pretitle: product.pretitle || "",
      genericName: product.genericName,
      isEquipment: product?.type.includes("equipment"),
      isRefurbished: product?.type.includes("reacondicionado"),
      offers: {
        r2r: null,
        r2rAdditional: null,
        libre: null,
      },
      regulatoryInfo: product.regulatoryInfo || null,
      bottomCardText: null
    }
    const { offers } = product;
    let swapOfferInfo;
    for (const key in offers) {
      const offer = offers[key];
      let offerVariant;
      if (Array.isArray(offer) && offer.length > 0) {
        //Se elige la primera capacidad/color de la oferta
        offerVariant = offer[0];
        //Nombre mas específico con capacidad (necesario para crosselling porque no viene :))
        productItem.name = offerVariant.name;

        const swapInfo = isMovistarSwapOffer(offerVariant);

        if (swapInfo.isSwapOffer) {
          swapOfferInfo = swapInfo;
        }

        if (!productItem.stamp) {
          productItem.stamp = getCustoStampByOffer(offerVariant, custoStamps)
        }

        //Para equipamiento vienen dos opciones por oferta, y hay que coger la más barata
        if (productItem.isEquipment) {
          const compareByCurrentPrice = (a, b) => {
            if (a && b) {
              return a?.currentPrice - b?.currentPrice;
            }
          };
          offerVariant = offer.sort(compareByCurrentPrice)[0];
        }
        productItem.labelPromo = offerVariant?.stamps?.[0];
        productItem.image = `https://www.movistar.es${getMainImageDevice(offerVariant.imgs)}`;
        productItem.href = getFullUrl(
          offerVariant.externalProductDetailUrl || offerVariant.urlNewFicha,
          queryParams
        );
        productItem.bottomCardText = offerVariant.additionalPayment;

        //Si no hay texto contrubuido debajo de la card, se muestra la financiación
        if (!productItem.bottomCardText) {
          const financingAvailable = finalClientType === USUARIO_LIBRE_CON_LINEA_MOVIL &&
            Array.isArray(offerVariant.fundingOfferInfo) &&
            offerVariant.fundingOfferInfo.length > 0 &&
            userFinancing;

          if (financingAvailable) {
            productItem.bottomCardText = "Financiación disponible"
          }
        }

        if (!productItem.isEquipment) {
          if (
            key === "r2r" &&
            (finalClientType === USUARIO_NO_LOGADO || finalClientType === USUARIO_PRIMER_R2R_INCLUIDO || finalClientType === USUARIO_SEGUNDO_R2R_INCLUIDO || (finalClientType === USUARIO_R2R_ADICIONAL_CON_RENOVACION && hasToShowR2RRenovationOffers)) &&
            !productItem.offers.r2r
          ) {
            const { monthlyFinalPrice, monthlyPriceBeforeDiscounts, totalAmount, installments } = getR2RPriceByFusionCategory(offerVariant, finalFusionCategoryId, key);
            const pvpr = offerVariant.originalPrice;
            let type = key;

            const offer = composeOfferObject({
              type,
              finalPrice: totalAmount,
              finalPriceBeforeDiscounts: pvpr,
              monthlyFinalPrice,
              installments,
              finalFusionCategoryId,
              errorCategoryFusionInfo,
              swapOfferInfo,
              userDiscountNewModelR2R,
            });
            productItem.offers = {
              ...productItem.offers,
              ...offer
            };
          } else if (
            key === "r2rAdditional" &&
            (finalClientType === USUARIO_R2R_ADICIONAL || finalClientType === USUARIO_R2R_ADICIONAL_CON_RENOVACION && !hasToShowR2RRenovationOffers) &&
            !productItem.offers.r2rAdditional
          ) {
            const { monthlyFinalPrice, moreThanOneQuota, totalAmount, installments } = getR2RPriceByFusionCategory(offerVariant, finalFusionCategoryId, key);
            const pvpr = offerVariant.originalPrice;

            const offer = composeOfferObject({
              type: key,
              finalPrice: totalAmount,
              //pvpr -> Ensure that finalPriceBeforeDiscounts is only set if totalAmount is less than pvpr
              finalPriceBeforeDiscounts: totalAmount < pvpr ? pvpr : null,
              monthlyFinalPrice,
              installments,
              finalFusionCategoryId,
              errorCategoryFusionInfo,
              moreThanOneQuota,
              swapOfferInfo,
              totalAmount,
            });
            productItem.offers = {
              ...productItem.offers,
              ...offer
            };
          } else if (key === "libre") {
            const { finalPrice, finalPriceBeforeDiscounts } = getFreeOfferPrice(offerVariant);
            const offer = composeOfferObject({
              type: key,
              finalPrice,
              finalPriceBeforeDiscounts,
              finalFusionCategoryId,
              errorCategoryFusionInfo
            });
            productItem.offers = {
              ...productItem.offers,
              ...offer
            };
          } else if (key.startsWith("r2r_")) {
            //Check colectivos
            const offerType = key.split("_")[0];
            const offerProfile = key.split("_")[1];
            if (Array.isArray(profiles) && profiles.length > 0) {
              for (const profileId of profiles) {
                if (offerProfile === `${profileId}`) {
                  const { monthlyFinalPrice, monthlyPriceBeforeDiscounts, totalAmount, installments } = getR2RPriceByFusionCategory(offerVariant, finalFusionCategoryId, offerType);
                  const pvpr = offerVariant.originalPrice;
                  let type = offerType;
                  const offerSaving = calculateSavingR2R({ equivalentFreePriceBeforeDiscounts: pvpr, totalAmount });

                  const offer = composeOfferObject({
                    type,
                    finalPrice: totalAmount,
                    finalPriceBeforeDiscounts: pvpr,
                    finalFusionCategoryId,
                    errorCategoryFusionInfo,
                    monthlyFinalPrice,
                    installments,
                    swapOfferInfo,
                    profileId,
                    userDiscountNewModelR2R,
                    offerSaving
                  });

                  productItem.offers = {
                    ...productItem.offers,
                    ...offer
                  };
                  break;
                }
              }
            }
          }
        } else {
          //En equipamiento se intenta recuperar el precio de libre de la oferta que se pueda
          const { finalPrice, finalPriceBeforeDiscounts } = getFreeOfferPrice(offerVariant);
          const libre = {
            title: '',
            finalPrice,
            finalPriceBeforeDiscounts,
            currency: '€',
          }
          productItem.offers.libre = libre;
        }
      }
    }
    let saving;
    if (productItem.offers.libre) {
      if (Object.keys(productItem.offers).filter(
        key => !!productItem.offers[key]
      ).length > 1) {
        // Compact view (only title with price) for free with r2r offers (not logged user)
        if (finalClientType === USUARIO_NO_LOGADO) {
          productItem.offers.libre.title = `Libre <span style="color:#262423">${productItem.offers.libre.finalPrice} €</span>`;
          productItem.offers.libre.compact = true;
        } else {
          delete productItem.offers.libre;
        }
      }
    }
    if ((productItem.offers.r2r || productItem.offers.r2rAdditional) && !productItem.isEquipment) {
      const targetR2R = productItem.offers.r2r || productItem.offers.r2rAdditional;
      saving = calculateSavingR2R({
        equivalentFreePriceBeforeDiscounts: targetR2R.finalPriceBeforeDiscounts,
        totalAmount: targetR2R.finalPrice
      })
    } else if (productItem.offers.libre) {
      saving = Math.round(
        productItem.offers.libre.finalPriceBeforeDiscounts - productItem.offers.libre.finalPrice
      );
    }
    if (saving > SAVING_LIMIT_PRICE && !swapOfferInfo?.isSwapOffer) {
      productItem.labelSaving = `Ahorro ${saving} €`;
    }
    if (productItem.offers.libre || productItem.offers.r2r || productItem.offers.r2rAdditional) {
      productsCards.push(productItem)
    }
  })
  return productsCards;
}

export const normalizeProductsToAutocomplete = ({ products }) => {
  const autocompleteItems = [];
  products.forEach((product) => {
    const { offers } = product;
    let offerVariant;
    for (const key in offers) {
      const offer = offers[key];
      if (Array.isArray(offer) && offer.length > 0) {
        //Se elige la primera capacidad/color de la oferta
        offerVariant = offer[0];
        const productItem = {
          name: product.name,
          href: getFullUrl(
            offerVariant.externalProductDetailUrl || offerVariant.urlNewFicha
          ),
        }
        autocompleteItems.push(productItem);
        break;
      }
    }
  });
  return autocompleteItems;
}